// removed by extract-text-webpack-plugin
module.exports = {"root":"attendee-data--root--ti8FHwSt","odd":"attendee-data--odd--3yWrSEwI","even":"attendee-data--even--3MHooD0T","delete":"attendee-data--delete--9czVIa80","tdDelete":"attendee-data--tdDelete--3JcSINvf","key":"attendee-data--key--1UIM8WQd"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/attendee-data/styles.css
// module id = ./views/order-detail/attendee-data/styles.css
// module chunks = 0